import React from 'react';
import "./style.css";
import { ArrowUp } from '../../../icons';

const colorMap = {
  low: '#00A878',
  medium: '#FF9900',
  high: '#EB0000'
}

const TaskPriority = ({
  priority
}) => (
    <div className="prio-icon">
      <ArrowUp color={colorMap[priority]} />
    </div>
  );

export default TaskPriority;



// WEBPACK FOOTER //
// ./src/components/TaskListItem/TaskPriority/index.js